var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"hide-footer":"","centered":"","size":"xl"},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_vm._v(" Order History ")]},proxy:true}]),model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('data-table',{attrs:{"fields":_vm.fields,"loading":_vm.loading,"items":_vm.orderData},scopedSlots:_vm._u([{key:"closePrice",fn:function(ref){
var data = ref.data;
return [_c('span',[_vm._v(" "+_vm._s(data.item.closePrice || "-")+" ")])]}},{key:"closeTime",fn:function(ref){
var data = ref.data;
return [_c('span',[_vm._v(" "+_vm._s(data.item.closeTime || "-")+" ")])]}},{key:"comment",fn:function(ref){
var data = ref.data;
return [_c('span',[_vm._v(" "+_vm._s(data.item.comment || "-")+" ")])]}},{key:"actions",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.actions || "-")+" ")]}},{key:"commission",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.commission || "-")+" ")]}},{key:"expiration",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.expiration || "-")+" ")]}},{key:"lots",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.lots || "-")+" ")]}},{key:"magicNumber",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.magicNumber || "-")+" ")]}},{key:"openPrice",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.openPrice || "-")+" ")]}},{key:"openTime",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.openTime || "-")+" ")]}},{key:"profit",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.profit || "-")+" ")]}},{key:"rateClose",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.rateClose || "-")+" ")]}},{key:"rateMargin",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.rateMargin || "-")+" ")]}},{key:"rateOpen",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.rateOpen || "-")+" ")]}},{key:"stopLoss",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.stopLoss || "-")+" ")]}},{key:"swap",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.swap || "-")+" ")]}},{key:"symbol",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.symbol || "-")+" ")]}},{key:"ticket",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.ticket || "-")+" ")]}},{key:"type",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(data.item.type || "-")+" ")]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }